import TextField from '@mui/material/TextField';
import { FormControl, styled } from '@mui/material';
import { filledInputClasses } from '@mui/material/FilledInput';
import { inputBaseClasses } from '@mui/material/InputBase';
import { config } from 'public/styles/config';
import { PublicTextFieldInputProps } from './types';
import { StyledFormInputLabel } from '../../forms/form-input-label/form-input-label';
import { StyledFormHelperText } from '../../forms/form-helper-text/form-helper-text';

export const PublicTextFieldInput = ({
  label,
  name,
  value,
  onChange,
  required,
  error,
  type,
}: PublicTextFieldInputProps) => {
  return (
    <FormControl variant="filled" fullWidth>
      <StyledFormInputLabel required={required} id={`${label}-label`}>
        {label}
      </StyledFormInputLabel>
      <StyledTextField
        id={name}
        name={name}
        title={label}
        value={value}
        type={type}
        variant="filled"
        fullWidth
        onChange={onChange}
      />
      {error ? <StyledFormHelperText>{error}</StyledFormHelperText> : null}
    </FormControl>
  );
};

const StyledTextField = styled(TextField)(({ theme }) => ({
  [`& .${filledInputClasses.root}`]: {
    borderRadius: theme.spacing(1),
  },
  [`& .${inputBaseClasses.input}`]: {
    fontFamily: config.fontFamily,
    fontSize: theme.typography.pxToRem(14),
    fontVariationSettings: '"wght" 500',
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));
